export default "__VITE_ASSET__BypxSfjl__"